export const USER_SET = "USER_SET";
export const USER_UNSET = "USER_UNSET";

export const USER_FRIEND_REQUEST = "USER_FRIEND_REQUEST";
export const USER_HIDE_FRIEND_REQUEST = "USER_HIDE_FRIEND_REQUEST";

export const USER_REQUESTING = "USER_REQUESTING";
export const USER_MODIFY = "USER_MODIFY";
export const USER_MODIFY_PICTURE = "USER_MODIFY_PICTURE";

export const USER_MODIFY_NAME = "USER_MODIFY_NAME";
export const USER_MODIFY_REQUESTING = "USER_MODIFY_REQUESTING";
export const USER_MODIFY_ERROR = "USER_MODIFY_ERROR";

export const USER_DEVICE = "USER_DEVICE";
export const USER_FOCUS = "USER_FOCUS";
export const USER_UNFOCUS = "USER_UNFOCUS";

export const NOTIFICATIONS_SEEN = "NOTIFICATIONS_SEEN";

export const NOTIFICATIONS_NEW = "NOTIFICATIONS_NEW";

export const USER_ADD_DEVICE_ID = "USER_ADD_DEVICE_ID";

export const USER_SEND_PULSE_NOTIFICATION_REQUESTING =
  "USER_SEND_PULSE_NOTIFICATION_REQUESTING";
export const USER_SEND_PULSE_NOTIFICATION_SUCCESS =
  "USER_SEND_PULSE_NOTIFICATION_SUCCESS";
export const USER_SEND_PULSE_NOTIFICATION_ERROR =
  "USER_SEND_PULSE_NOTIFICATION_ERROR";

export const USER_GET_COMPANY_LOGO_REQUESTING =
  "USER_GET_COMPANY_LOGO_REQUESTING";
export const USER_GET_COMPANY_LOGO_SUCCESS = "USER_GET_COMPANY_LOGO_SUCCESS";
export const USER_GET_COMPANY_LOGO_ERROR = "USER_GET_COMPANY_LOGO_ERROR";

export const UPDATE_USER_WITHOUT_RESPONSE_REQUESTING =
  "user/UPDATE_USER_WITHOUT_RESPONSE_REQUESTING";
export const UPDATE_USER_WITHOUT_RESPONSE_SUCCESS =
  "user/UPDATE_USER_WITHOUT_RESPONSE_SUCCESS";
export const UPDATE_USER_WITHOUT_RESPONSE_ERROR =
  "user/UPDATE_USER_WITHOUT_RESPONSE_ERROR";

export const MY_USERS_DELETE_REQUESTING = "MY_USERS_DELETE_REQUESTING";
export const MY_USERS_DELETE_SUCCESS = "MY_USERS_DELETE_SUCCESS";
export const MY_USERS_DELETE_ERROR = "MY_USERS_DELETE_ERROR";
